import { z } from 'zod';

export const apiTokenSchema = z
  .object({
    access_token: z.string().min(1),
    token_type: z.string().min(1),
  })
  .transform((data) => ({
    accessToken: data.access_token,
    tokenType: data.token_type,
  }));

export const tokenSchema = z.object({
  accessToken: z.string().min(1),
  tokenType: z.string().min(1),
});

export const authorizeTokenSchema = z.object({
  username: z.string().min(1),
  token: apiTokenSchema,
});

export type AuthToken = z.infer<typeof tokenSchema>;
